import { createSvgComponent } from "../../icon/createSvgComponent";
import ExpandWindow from "@core/__generated__/icon/figma/expand-window.svg";
export default createSvgComponent(ExpandWindow);